import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import dompurify from 'dompurify';
import sanitizerConfig from '../sanitizer-config';

interface UploadDoneProps {
    thankYouMessage: string;
    reset: () => void;
}

const UploadDone = ({ thankYouMessage, reset }: UploadDoneProps): ReactElement => {
    const { t } = useTranslation();
    const sanitizer = dompurify.sanitize;

    return (<>
        <h1 className="text-4xl lg:text-5xl font-bold leading-tight mb-2">{t('successTitle')}</h1>
        <div className="mb-10 text-xl break-words upload-content">
            { thankYouMessage &&
            <div dangerouslySetInnerHTML={{ __html: sanitizer(thankYouMessage,sanitizerConfig ) }} />
            }
            { !thankYouMessage && t('successDefaultMessage') }
        </div>
        <button onClick={reset} className="upload-btn block w-full mx-auto lg:max-w-sm" id="buttonStartOver">
            {t('uploadButtonUploadMore')}
        </button>
    </>);
};

export default UploadDone;
